import { FC, useMemo } from "react";
import { ColDef } from "ag-grid-community";
import {
  NormalizedWidgetAggregatedCost,
  WidgetNormalizedCostVisualization,
} from "@/services/cloudchipr.api";
import { NormalizedCostWidgetTableDataType } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/utils/types/types";
import { AgDataGrid } from "@/components/pages/common/ag-grid/AgDataGrid";
import { getNormalizedCostWidgetTableColDef } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/table/normalizedCostWidgetTableColDef";

interface NormalizedCostWidgetTableViewProps {
  loading?: boolean;
  regular?: NormalizedWidgetAggregatedCost[];
  normalized?: NormalizedWidgetAggregatedCost[];
  visualization?: WidgetNormalizedCostVisualization;
}

export const NormalizedCostWidgetTableView: FC<
  NormalizedCostWidgetTableViewProps
> = ({ regular, normalized, loading, visualization }) => {
  const data: NormalizedCostWidgetTableDataType[] | undefined = useMemo(
    () =>
      regular?.map((value, index) => ({
        id: index,
        date: value.value,
        regular: value,
        normalized: normalized?.at(index),
      })),
    [normalized, regular],
  );

  const columnDefs = useMemo(
    () => getNormalizedCostWidgetTableColDef(visualization),
    [visualization],
  );

  return (
    <AgDataGrid
      loading={loading}
      rowHeight={40}
      headerHeight={44}
      rowData={data ?? []}
      columnDefs={columnDefs}
      defaultColDef={defaultColDef}
    />
  );
};

const defaultColDef: ColDef = {
  flex: 1,
  unSortIcon: true,
  lockVisible: true,
  suppressColumnsToolPanel: true,
  suppressHeaderContextMenu: true,
};
